var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2377 3L10.2377 8.44796L11.7622 7.9398C11.9161 7.88849 12.0826 7.88849 12.2365 7.9398L13.761 8.44796V3H10.2377ZM8.73772 3L8.73772 9.48853C8.73772 9.72961 8.85361 9.95599 9.04918 10.097C9.24476 10.2379 9.49618 10.2763 9.72489 10.2L11.9993 9.44189L14.2738 10.2C14.5025 10.2763 14.7539 10.2379 14.9495 10.097C15.1451 9.95599 15.261 9.72961 15.261 9.48853V3H16.186C18.8447 3 21 5.15528 21 7.81395V16.186C21 18.8447 18.8447 21 16.186 21H7.81395C5.15528 21 3 18.8447 3 16.186V7.81395C3 5.15528 5.15528 3 7.81395 3H8.73772ZM14.4239 16.1859C14.4239 16.6001 14.0881 16.9359 13.6739 16.9359H10.325C9.9108 16.9359 9.57502 16.6001 9.57502 16.1859C9.57502 15.7717 9.9108 15.4359 10.325 15.4359H13.6739C14.0881 15.4359 14.4239 15.7717 14.4239 16.1859Z",
    fill: "#D5DAE0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSales);
export default __webpack_public_path__ + "static/media/sales.33e6830a2930b440975b8b47824dae0a.svg";
export { ForwardRef as ReactComponent };